// extracted by css-extract-rspack-plugin
export default {"cls1":"useFirstSuggestedWorkToast-cls1_An6","cls2":"useFirstSuggestedWorkToast-cls2_vzj useFirstSuggestedWorkToast-cls1_An6"};